// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_container {
  font-family: mreaves-regular;
}

.main-div {
  height: 100vh;
  width: 425px;
  position: relative;
  margin: auto;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  .main-div {
    width: 80%;
  }
}

.child-div {
  width: 100%;
  margin: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.site-logo {
  margin-bottom: 30PX;
  width: 100%;
}

.text-center {
  text-align: center;
}

.crm-text {
  text-align: center;
  font-size: 50px;
  margin-top: 30PX;
  line-height: 50px;
  margin-bottom: 0;
  font-weight: lighter;
}

input:focus {
  border-color: black !important;
  outline: none !important;
  box-shadow: none !important;
}

.form-section input {
  border-color: black;
  color: black;
  height: 60px;
  margin-bottom: 20px;
}

.form-section .input-group-text {
  background-color: transparent;
  border-color: black;
  border-left-color: transparent;
}

.password_view {
  color: #DBB7BB !important;
}

.login-btn {
  background-color: #0E0E0E !important;
  padding: 5px 35px !important;
  border-radius: 0px !important;
  color: white !important;
  width: max-content;
  font-size: 20px !important;
  width: 100%;
  text-transform: uppercase;
}

.border-none {
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/css/login.scss"],"names":[],"mappings":"AAAA;EACI,4BAAA;AACJ;;AAEA;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AACJ;AAAI;EALJ;IAMQ,UAAA;EAGN;AACF;;AAAA;EACI,WAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;EAEA,2BAAA;AAGJ;;AAAA;EACI,mBAAA;EACA,WAAA;AAGJ;;AAAA;EACI,kBAAA;AAGJ;;AAAA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;AAGJ;;AAAA;EACI,8BAAA;EACA,wBAAA;EACA,2BAAA;AAGJ;;AAAA;EACI,mBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AAGJ;;AAAA;EACI,6BAAA;EACA,mBAAA;EACA,8BAAA;AAGJ;;AAQA;EACI,yBAAA;AALJ;;AAQA;EACI,oCAAA;EACA,4BAAA;EACA,6BAAA;EACA,uBAAA;EACA,kBAAA;EACA,0BAAA;EACA,WAAA;EACA,yBAAA;AALJ;;AAQA;EACI,YAAA;AALJ","sourcesContent":[".login_container {\n    font-family: mreaves-regular;\n}\n\n.main-div {\n    height: 100vh;\n    width: 425px;\n    position: relative;\n    margin: auto;\n    @media all and (min-width: 0px) and (max-width: 600px) {\n        width: 80%;\n    }\n}\n\n.child-div {\n    width: 100%;\n    margin: 0;\n    position: absolute;\n    top: 50%;\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n}\n\n.site-logo {\n    margin-bottom: 30PX;\n    width: 100%;\n}\n\n.text-center {\n    text-align: center;\n}\n\n.crm-text {\n    text-align: center;\n    font-size: 50px;\n    margin-top: 30PX;\n    line-height: 50px;\n    margin-bottom: 0;\n    font-weight: lighter;\n}\n\ninput:focus {\n    border-color: black!important;\n    outline: none!important;\n    box-shadow: none!important;\n}\n\n.form-section input {\n    border-color: black;\n    color: black;\n    height: 60px;\n    margin-bottom: 20px;\n}\n\n.form-section .input-group-text {\n    background-color: transparent;\n    border-color: black;\n    border-left-color: transparent;\n}\n\n.form-section .password_input {\n    // border-right-color: transparent;\n}\n\n.password_input:focus {\n    // border-right-color: transparent!important;\n}\n\n.password_view {\n    color: #DBB7BB!important;\n}\n\n.login-btn {\n    background-color: #0E0E0E !important;\n    padding: 5px 35px !important;\n    border-radius: 0px !important;\n    color: white !important;\n    width: max-content;\n    font-size: 20px !important;\n    width: 100%;\n    text-transform: uppercase;\n}\n\n.border-none {\n    border: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
